<template>
  <div v-if="device" class="container">
    <div class="title">
      <h1>{{device.name}}</h1>
      <span>#{{device.uuid}}</span>
    </div>
    <div class="action-panel">
      <div class="btn" v-on:click="showManageAccess = 1">Manage device-access</div>
    </div>
    <div class="split">
      <div>
        <div class="index">
          <h2>Index</h2>
          <div class="scroll">
            <p
              v-for="(val, key, index) in deviceSpecs"
              :key="index"
              v-on:click="scrollToView('element-in-index-' + index)"
            >{{key}}</p>
          </div>
        </div>
      </div>
      <div>
        <div class="title sm">
          <h2>Longtime statistics</h2>
        </div>
        <p class="no-result">Comming soon</p>
        <div class="title sm">
          <h2>System information</h2>
          <span class="age">Data gatered {{timeSinceText}} ago</span>
        </div>
        <div v-for="(val, key, index) in deviceSpecs" :key="index">
          <h3 class="element-in-index" :id="'element-in-index-' + index">{{key}}</h3>
          <span v-if="typeof val !== 'object'">{{val}}</span>
          <div v-else class="table">
            <div v-for="(val1, key1, index1) in val" :key="index1">
              <p>{{key1}}</p>
              <span v-if="typeof val1 !== 'object'">{{val1}}</span>
              <div v-else class="table">
                <div v-for="(val2, key2, index2) in val1" :key="index2">
                  <p>{{key2}}</p>
                  <span v-if="typeof val2 !== 'object'">{{val2}}</span>
                  <div v-else class="table">
                    <div v-for="(val3, key3, index3) in val2" :key="index3">
                      <p>{{key3}}</p>
                      <span v-if="typeof val3 !== 'object'">{{val3}}</span>
                      <div v-else class="table">
                        <div v-for="(val4, key4, index4) in val3" :key="index4">
                          <p>{{key4}}</p>
                          <span>{{val4}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" v-if="showManageAccess">
      <div class="modal-body">
        <h2>Manage device-access</h2>
        <p class="no-result">Comming soon</p>
        <div class="action-panel">
          <div class="btn" v-on:click="showManageAccess = null">Close</div>
        </div>
      </div>
    </div>
  </div>
  <Loading v-else/>
</template>
<style lang="scss" scoped>
.split {
  display: flex;
  & > * {
    &:first-child {
      margin: 0 2rem 0 0;
      flex-shrink: 0;
    }
    &:last-child{
      flex-grow: 2;
    }
  }
  @media(max-width: 600px){
    flex-direction: column;
    &>*:first-child{
      margin: 0 0 2rem 0;
    }
    .scroll{
      overflow: hidden;
      max-height: unset;
      display: flex;
      flex-wrap: wrap;
      &>*{
        width: 50%;
      }
    }
  }
}
.title {
  margin-bottom: 3rem;
  &.sm {
    margin-bottom: 1rem;
  }
  &:not(:first-child){
    margin-top: 4rem;
  }
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-end;
  cursor: default;
  h1,
  h2 {
    margin: 0;
  }
  span {
    display: block;
    text-align: right;
    margin-left: auto;
    opacity: 0.7;
  }
}
.index {
  user-select: none;
  //max-height: calc(100vh - 2rem);
  border-radius: 5px;
  background-color: var(--bg-color-2);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  h2 {
    margin: 1rem 1rem 10px 1rem;
    flex-shrink: 0;
  }
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .scroll {
    overflow-x: auto;
    flex-grow: 2;
    &::-webkit-scrollbar {
        display: none;
    }
    p{
      padding: 10px 1rem;
      border-radius: 5px;
      margin: 0;
      cursor: pointer;
      transition: background-color 300ms ease, box-shadow 300ms ease;
      &:hover{
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        background-color: var(--bg-color-3);
      }
    }
    }
    &:first-letter {
      text-transform: uppercase;
    }
  }

.age {
  text-align: right;
}
h3 {
  margin: 1.5rem 0 10px 0;
  &:first-letter {
    text-transform: uppercase;
  }
}
.title.sm + div > h3 {
  margin-top: 0;
}
.table {
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    &:not(:last-child) {
      border-bottom: 1px solid rgba(gray, 0.4);
    }
    &:nth-child(2n-1) {
      background-color: var(--bg-color-2);
    }
    &:nth-child(2n) {
      background-color: var(--main-bg-color);
    }
    p {
      margin: 0 15px 0 0;
      max-width: max-content;
      &:first-letter {
        text-transform: uppercase;
      }
    }
    span {
      flex-grow: 2;
      text-align: right;
    }
    div {
      flex-grow: 2;
    }
    p + div {
      margin-left: 1.5rem;
    }
  }
}
</style>

<script>
import Loading from "@/components/parts/Loading.vue";
export default {
  name: "Device",
  components: { Loading },
  data() {
    return {
      timer: null,
      timeSinceText: null,
      showManageAccess: null,
    };
  },
  computed: {
    device: function() {
      return this.$store.state.stats.devices.find(device => {
        return device.uuid == this.$route.params.uuid;
      });
    },
    deviceSpecs: function() {
      return JSON.parse(
        this.$store.state.stats.devices.find(device => {
          return device.uuid == this.$route.params.uuid;
        }).systemdata
      );
    }
  },
  methods: {
    timeSince: function() {
      this.updateTimeSince();
      this.timer = setInterval(() => {
        this.updateTimeSince();
      }, 1000);
    },
    updateTimeSince: function() {
      var span = (new Date() - new Date(this.device.lastupdate)) / 1000;
      var text = "";
      span = Math.round(span);
      if (span > 31556926) {
        text += Math.floor(span / 31556926);
        if (Math.floor(span / 31556926) == 1) {
          text += " year ";
        } else {
          text += " years ";
        }
        span -= Math.floor(span / 31556926) * 31556926;
      }
      if (span > 2629743.83) {
        text += Math.floor(span / 2629743.83);
        if (Math.floor(span / 2629743.83) == 1) {
          text += " month ";
        } else {
          text += " months ";
        }
        span -= Math.floor(span / 2629743.83) * 2629743.83;
      }
      if (span > 86400) {
        text += Math.floor(span / 86400);
        if (Math.floor(span / 86400) == 1) {
          text += " day ";
        } else {
          text += " days ";
        }
        span -= Math.floor(span / 86400) * 86400;
      }
      if (span > 3600) {
        text += Math.floor(span / 3600);
        if (Math.floor(span / 3600) == 1) {
          text += " hour ";
        } else {
          text += " hours ";
        }
        span -= Math.floor(span / 3600) * 3600;
      }
      if (span > 60) {
        text += Math.floor(span / 60);
        if (Math.floor(span / 60) == 1) {
          text += " minute ";
        } else {
          text += " minutes ";
        }
        span -= Math.floor(span / 60) * 60;
      }
      if (span > 0) {
        text += span;
        if (span == 1) {
          text += " second";
        } else {
          text += " seconds";
        }
      } else {
        text = text.substr(0, text.length - 1);
      }
      this.timeSinceText = text;
    },
    scrollToView: function(index) {
      document.getElementById(index).scrollIntoView();
    },
    getDevices: function() {
      var vue = this;
      vue.$socket.client.emit("getDevices", null, (error, response) => {
        vue.$store.state.stats.devices = response;
        this.timeSince();
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {
    this.getDevices();
  },
};
</script>